import { XMarkIcon } from "@heroicons/react/24/outline"
import React, { useEffect, useRef } from "react"
import { twMerge } from "tailwind-merge"

const Toast = ({ children, position, type, visible, setVisible, timeout = 6000, showCloseButton = true }) => {
  const timeoutRef = useRef(null)

  useEffect(() => {
    if (visible) {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => {
        setVisible(false)
      }, timeout)
    }
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [visible, timeout, setVisible])

  const getPositionClasses = () => {
    switch (position) {
      case "bottomLeft":
        return visible ? "bottom-8 left-8" : "bottom-8 -left-[460px]"
      case "topLeft":
        return visible ? "top-8 left-8" : "top-8 -left-[460px]"
      case "bottomCenter":
        return visible ? "bottom-8 left-1/2 -translate-x-1/2" : "-bottom-32 left-1/2 -translate-x-1/2"
      case "topCenter":
        return visible
          ? "top-8 left-1/2 -translate-x-1/2"
          : "top-8 left-1/2 -translate-x-1/2 opacity-0 scale-95 pointer-events-none"
      case "center":
        return visible
          ? "top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-100 scale-100"
          : "top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 scale-95 pointer-events-none"
      default:
        return visible ? "top-8 left-8" : "top-8 -left-[460px]"
    }
  }

  const handleClose = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    setVisible(false)
  }

  return (
    <div
      className={twMerge(
        "fixed z-[999999] flex h-[56px] w-[460px] items-center rounded border px-6 transition-all duration-500 sm:w-[calc(100%-4rem)] sm:max-w-[460px] [&>a]:cursor-pointer [&>a]:font-bold [&>a]:underline",
        type === "error"
          ? "border-red bg-red-light"
          : type === "warning"
          ? "border-orange bg-orange-light"
          : type === "info"
          ? "border-gray bg-gray-light"
          : "border-green bg-[#E7FFE3]",
        getPositionClasses()
      )}>
      <div className="flex flex-1 items-center">
        <span className="font-manrope text-[16px] font-bold leading-[24px] text-[#0b3954]">{children}</span>
      </div>
      {showCloseButton && (
        <button
          onClick={handleClose}
          className="ml-4 flex h-6 w-6 shrink-0 items-center justify-center text-[#0b3954] transition-colors hover:opacity-70 focus:outline-none">
          <XMarkIcon className="h-5 w-5" />
        </button>
      )}
    </div>
  )
}

export default Toast
